// loanType is actually tradeLineType which comes in STUDENT | MORTGAGE | HELOC | AUTO
// We want to convert those enoms to Student | Mortgage | Heloc | Auto | etc
const normalizeLoanType = (tradelineType) =>
	tradelineType &&
	tradelineType[0].toUpperCase() + tradelineType.slice(1).toLowerCase();

export default normalizeLoanType;
